import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
var threadListParams = {
  perPage: 10,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 3,
  sequence: 0,
  'filter[categoryids][0]': 3
};
import { threadList } from '@/api/mg';
export default {
  data: function data() {
    return {
      totalPage: 0,
      loading: false,
      finished: false,
      isLoading: false,
      videoData: [{
        threadId: 58
      }],
      infos: [{
        isFollow: true
      }, {
        isFollow: false
      }, {
        isFollow: true
      }, {
        isFollow: false
      }]
    };
  },
  created: function created() {
    threadListParams.page = 1;
    this.getThreadList(threadListParams);
  },
  methods: {
    toMe: function toMe(pid) {
      // this.$router.push({ path: '/me', query: { pid }})
    },
    onLoad: function onLoad() {
      threadListParams.page++;
      if (threadListParams.page <= this.totalPage) {
        this.getThreadList(threadListParams);
      } else {
        this.finished = true;
      }
    },
    getThreadList: function getThreadList(params) {
      var _this = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          _this.totalPage = res.Data.totalPage;
          _this.videoData = [].concat(_toConsumableArray(res.Data.pageData), _toConsumableArray(_this.videoData));
          _this.loading = false;
          _this.isLoading = false;
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    onRefresh: function onRefresh() {
      this.finished = false;
      this.videoData = [];
      threadListParams.page = 1;
      this.getThreadList(threadListParams);
    },
    toDetail: function toDetail(threadId) {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: 'video',
          threadId: threadId
        }
      });
    }
  }
};